import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import LineupModal from './LineupModal';
import Lineup from './Lineup';
import LogInModal from 'flarum/forum/components/LogInModal';
import CommunityLineupsModal from './CommunityLineupsModal';
const dayjs = window.dayjs;
export default class UserMatchLineupWidget extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.match = this.attrs.match;
    this.submitting = false;

    // Find existing lineup prediction for the current user
    this.existingLineup = null;
    this.updateExistingLineup();
  }
  updateExistingLineup() {
    if (app.session.user && this.match.userMatchLineups()) {
      const userId = app.session.user.id();
      this.existingLineup = this.match.userMatchLineups().find(l => String(l.userId()) === String(userId));
    } else {
      this.existingLineup = null;
    }
  }
  view() {
    this.updateExistingLineup();
    const matchDate = this.match.matchDate();
    const deadline = matchDate ? dayjs(matchDate).subtract(2, 'hours') : null;
    const votingClosed = deadline && dayjs().isAfter(deadline);
    const totalLineups = this.match.userMatchLineups() ? this.match.userMatchLineups().length : 0;
    if (this.match.isSuspendedWithoutLineup()) {
      return m("div", {
        className: "BolillaWidget UserMatchLineupWidget UserMatchLineupWidget--suspended",
        style: "border: 1px solid rgba(239, 68, 68, 0.3); background: rgba(239, 68, 68, 0.05); border-radius: 12px; padding: 24px; text-align: center; margin-bottom: 20px;"
      }, m("div", {
        style: "font-size: 2.2rem; color: #ef4444; margin-bottom: 10px;"
      }, m("i", {
        className: "fas fa-ban"
      })), m("h3", {
        style: "margin: 0 0 8px 0; color: #ef4444; font-size: 1.25em; font-weight: 700;"
      }, "11 Aldeanos: Partido Suspendido"), m("p", {
        style: "margin: 0 auto; color: var(--muted-color); font-size: 0.95em; max-width: 500px; line-height: 1.5;"
      }, "El partido ha sido suspendido y este pron\xF3stico de 11 Aldeanos ha quedado cancelado sin asignaci\xF3n de puntos."));
    }
    return m("div", {
      className: "BolillaWidget UserMatchLineupWidget"
    }, m("div", {
      className: "BolillaWidget-Header"
    }, m("h3", null, m("i", {
      className: "fas fa-futbol"
    }), " 11 Aldeanos: ", this.match.getName())), m("div", {
      className: "BolillaWidget-deadline ".concat(votingClosed ? 'closed' : '')
    }, votingClosed ? m("span", {
      className: "closed"
    }, m("i", {
      className: "fas fa-lock"
    }), " Votaci\xF3n cerrada") : deadline && m("span", null, m("i", {
      className: "far fa-clock"
    }), " Cierra ", dayjs(deadline).fromNow())), this.match.isSuspendedWithLineup() && m("div", {
      style: "margin: 8px auto 0 auto; background: rgba(16, 185, 129, 0.1); border: 1px solid rgba(16, 185, 129, 0.3); color: #10b981; border-radius: 8px; padding: 8px 12px; font-size: 0.85em; font-weight: 600; display: inline-flex; align-items: center; gap: 6px;"
    }, m("i", {
      className: "fas fa-check-circle"
    }), "Partido suspendido: los puntos de 11 Aldeanos se mantienen contabilizados en la clasificaci\xF3n."), !app.session.user ? m("div", {
      className: "BolillaWidget-GuestMessageWrapper",
      style: "text-align: center; padding: 25px 15px;"
    }, m("p", {
      className: "BolillaWidget-GuestMessage",
      style: "margin-bottom: 15px; font-weight: 500;"
    }, "Inicia sesi\xF3n para participar en 11 Aldeanos."), m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(LogInModal)
    }, m("i", {
      className: "fas fa-sign-in-alt",
      style: "margin-right: 6px;"
    }), "Acceder al foro")) : m("div", {
      className: "BolillaWidget-Body",
      style: "display: flex; flex-direction: column; align-items: center; width: 100%; box-sizing: border-box;"
    }, this.existingLineup ? m("div", {
      className: "UserMatchLineup-Preview",
      style: "width: 100%; display: flex; flex-direction: column; align-items: center; gap: 15px;"
    }, m("p", {
      style: "font-weight: 600; text-align: center; margin: 0;"
    }, "Tu alineaci\xF3n guardada (", this.existingLineup.formation(), "):"), m("div", {
      className: "UserMatchLineup-pitch-preview",
      style: "width: 100%; max-width: 480px; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.15);"
    }, m(Lineup, {
      formation: this.existingLineup.formation(),
      kit: this.existingLineup.kit(),
      players: this.existingLineup.playersRaw()
    }))) : m("div", {
      className: "UserMatchLineup-EmptyState",
      style: "text-align: center; padding: 30px 15px; display: flex; flex-direction: column; align-items: center; gap: 10px;"
    }, m("div", {
      style: "font-size: 3rem; opacity: 0.3;"
    }, "\uD83D\uDCCB"), m("p", {
      style: "font-weight: 500; max-width: 320px; margin: 0;"
    }, "A\xFAn no has creado tu alineaci\xF3n pronosticada para este partido.")), !votingClosed && m("div", {
      className: "BolillaWidget-Actions",
      style: "margin-top: 20px;"
    }, m(Button, {
      className: "Button Button--primary",
      loading: this.submitting,
      onclick: this.openLineupForm.bind(this)
    }, m("i", {
      className: "fas fa-edit",
      style: "margin-right: 6px;"
    }), this.existingLineup ? 'Modificar alineación' : 'Crear alineación')), this.existingLineup && votingClosed && m("div", {
      className: "BolillaWidget-Result",
      style: "margin-top: 15px; text-align: center;"
    }, m("p", {
      style: "font-size: 0.95em;"
    }, "Votaci\xF3n cerrada. Tu alineaci\xF3n ha sido registrada."))), totalLineups > 0 && m("div", {
      className: "BolillaWidget-Footer"
    }, m(Button, {
      className: "Button Button--link BolillaWidget-DetailBtn",
      onclick: () => app.modal.show(CommunityLineupsModal, {
        match: this.match
      })
    }, m("i", {
      className: "fas fa-list-ul"
    }), " Ver alineaciones de la comunidad (", totalLineups, ")")));
  }
  openLineupForm() {
    app.modal.show(LineupModal, {
      lineup: this.existingLineup,
      onlyStarters: true,
      match: this.match,
      onsubmit: bbcode => {
        this.submitting = true;
        m.redraw();

        // Extract formation, kit and playersRaw from bbcode
        const matchFormation = bbcode.match(/formation="([^"]+)"/);
        const matchKit = bbcode.match(/kit="([^"]+)"/);
        const matchPlayers = bbcode.match(/\](.*?)\[\/lineup\]/);
        const formation = matchFormation ? matchFormation[1] : '4-4-2';
        const kit = matchKit ? matchKit[1] : 'athletic';
        const playersRaw = matchPlayers ? matchPlayers[1] : '';

        // Comprobación de seguridad: asegurar 11 titulares con ID
        const items = playersRaw.split(',').map(s => s.trim()).filter(Boolean);
        const starters = items.slice(0, 11);
        const invalidStarter = starters.find(item => {
          const parts = item.split(':');
          return parts.length < 3 || isNaN(Number(parts[1])) || !parts[1];
        });
        if (starters.length < 11 || invalidStarter) {
          app.alerts.show({
            type: 'error'
          }, 'En 11 Aldeanos debes seleccionar 11 jugadores titulares válidos de la plantilla.');
          this.submitting = false;
          m.redraw();
          return;
        }
        const starterIds = starters.map(item => item.split(':')[1]).filter(Boolean);
        if (new Set(starterIds).size !== 11) {
          app.alerts.show({
            type: 'error'
          }, 'En 11 Aldeanos no puedes repetir jugadores en el once titular.');
          this.submitting = false;
          m.redraw();
          return;
        }
        app.request({
          method: 'POST',
          url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/user-match-lineups',
          body: {
            data: {
              attributes: {
                matchId: this.match.id(),
                formation,
                kit,
                playersRaw
              }
            }
          }
        }).then(response => {
          const savedLineup = app.store.pushPayload(response);
          this.existingLineup = savedLineup;

          // Update match's relationships resolving cache
          if (!this.match.data.relationships) {
            this.match.data.relationships = {};
          }
          if (!this.match.data.relationships.userMatchLineups) {
            this.match.data.relationships.userMatchLineups = {
              data: []
            };
          }
          if (!Array.isArray(this.match.data.relationships.userMatchLineups.data)) {
            this.match.data.relationships.userMatchLineups.data = [];
          }
          const existsInLinkage = this.match.data.relationships.userMatchLineups.data.some(link => String(link.id) === String(savedLineup.id()));
          if (!existsInLinkage) {
            this.match.data.relationships.userMatchLineups.data.push({
              type: 'nagusi_user_match_lineups',
              id: savedLineup.id()
            });
          }
          if (this.match.related && this.match.related.userMatchLineups) {
            const index = this.match.related.userMatchLineups.findIndex(l => l.id() === savedLineup.id());
            if (index !== -1) {
              this.match.related.userMatchLineups[index] = savedLineup;
            } else {
              this.match.related.userMatchLineups.push(savedLineup);
            }
          }
          app.alerts.show({
            type: 'success'
          }, '¡Alineación guardada correctamente!');
          this.submitting = false;
          m.redraw();
        }).catch(err => {
          console.error("Error saving lineup prediction:", err);
          this.submitting = false;
          m.redraw();
        });
      }
    });
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/UserMatchLineupWidget', UserMatchLineupWidget);